// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"84763b72","297":"80ab6609","440":"42eec1b9","483":"1c35cb2d","532":"eaa6f4d9","683":"cf9133ad","752":"69df1738","849":"8951eef2","961":"88d8402b","972":"5712973b"}[chunkId] + ".chunk.js";
};